import classNames from 'classnames';
import PropTypes from 'prop-types';
import settings from '/@/core/settings';
import styles from './styles.module.css';

function Container(props) {
    const color = settings.app.theme === 'expertobayer' ? 'expertobayer' : props.color;

    const classNamesRoot = classNames(
        styles.root,
        props.color && styles[`gradient-${color}-${props.gradient}`],
        props.backgroundColor && styles[`bg-color-${props.backgroundColor}`],
        props.classNameRoot
    );

    const wrapperClassNames = classNames(styles.wrapper, props.className);

    return (
        <div className={classNamesRoot}>
            <div className={wrapperClassNames}>{props.children}</div>
        </div>
    );
}

Container.propTypes = {
    color: PropTypes.oneOf(['pink', 'blue']),
    gradient: PropTypes.oneOf(['initial', 'middle', 'center', 'center-v2', 'cover']),
    backgroundColor: PropTypes.oneOf(['gray', 'black']),
    className: PropTypes.string,
    classNameRoot: PropTypes.string,
};

export default Container;
